module.exports = {
  API_BASE_URL: process.env.REACT_APP_API_ROOT + "/api",
  BasicToken: "",
};
